import { styled } from '@mui/material';
import { breakpoints } from 'src/ui-components';

import { BrandPerformanceChart } from './components/brandPerformanceChart/BrandPerformanceChart';
import { InfoBlocks } from './components/infoBlocks/InfoBlocks';
import { SalesOverview } from './components/salesOverview/SalesOverview';
import { SalesTablePage } from './components/salesTable/SalesTable';
import { TopProducts } from './components/topProducts/TopProducts';

export const PerformanceCenter = () => {
  return (
    <Wrapper>
      <SalesOverview />
      <BrandPerformanceChart />
      <InfoBlocks />
      <TopProducts />
      {/*<TopProductsChart />*/}
      <SalesTablePage />
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 24px;

  ${breakpoints.before.desktop} {
    grid-template-columns: minmax(0, 1fr);
  }
`;
